import MediaTrigger from './mediaTrigger';

const mediaTriggerConfig = {
  name: 'mediaTrigger',
  class: MediaTrigger,
  querySelector: {
    controller: '.trigger',
  },
};

export default mediaTriggerConfig;
